import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  vehicles: [],
  loading: false,
  error: null,
  pagination: {
    totalPages: 0,
    totalElements: 0,
    currentPage: 0,
    pageSize: 10,
    isLastPage: false,
    isFirstPage: true,
  },
};

const vehicleSlice = createSlice({
  name: "vehicle",
  initialState,
  reducers: {
    fetchVehiclesStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchVehiclesSuccess(state, action) {
      state.vehicles = action.payload.vehicles;
      state.pagination = action.payload.pagination;
      state.loading = false;
      state.error = null;
    },
    fetchVehiclesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    addVehicleStart(state) {
      state.loading = true;
      state.error = null;
    },
    addVehicleSuccess(state, action) {
      state.loading = false;
      state.vehicles.unshift(action.payload);
      state.error = null;
    },
    addVehiclesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    deleteVehicleStart(state) {
      state.loading = true;
      state.error = null;
    },
    deleteVehicleSuccess(state, action) {
      state.loading = false;
      state.vehicles = state.vehicles.filter(
        (vehicle) => vehicle.id !== action.payload
      );
      state.error = null;
    },
    deleteVehicleFailure(state, action) {
      state.loading = true;
      state.error = action.payload;
    },
    editVehicleStart(state) {
      state.loading = true;
      state.error = null;
    },
    editVehicleSuccess(state, action) {
      state.loading = false;
      const updatedVehicle = action.payload;
      const index = state.vehicles.findIndex(
        (vehicle) => vehicle.id === updatedVehicle.id
      );
      if (index !== -1) {
        state.vehicles[index] = updatedVehicle;
      }
      state.error = null;
    },
    editVehicleFailure(state, action) {
      state.loading = true;
      state.error = action.payload;
    },

    // getCategoryByIdStart(state) {
    //   state.loading = false;
    //   state.error = null;
    //   state.selectedCategory = null;
    // },
    // getCategoryByIdSuccess(state, action) {
    //   state.loading = false;
    //   state.selectedCategory = action.payload;
    //   state.error = null;
    // },
    // getCategoryByIdFailure(state, action) {
    //   state.loading = false;
    //   state.error = action.payload;
    // },
    resetVehicles(state) {
      state.vehicles = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  fetchVehiclesStart,
  fetchVehiclesSuccess,
  fetchVehiclesFailure,
  addVehicleStart,
  addVehicleSuccess,
  addVehiclesFailure,
  deleteVehicleStart,
  deleteVehicleSuccess,
  deleteVehicleFailure,
  editVehicleStart,
  editVehicleSuccess,
  editVehicleFailure,
  //   getCategoryByIdFailure,
  //   getCategoryByIdStart,
  //   getCategoryByIdSuccess,
  resetVehicles,
} = vehicleSlice.actions;

export default vehicleSlice.reducer;
